import { t } from 'i18next';

import { IContactGroup } from 'contacts/types';
import { LinkCell } from 'core/elements';
import { LinkTarget } from 'core/enums';

import { ContactGroupIdCell, ContactGroupNameCell, DomainsCell } from './Cells';

export const commonColumns = (openDetails: (data: IContactGroup) => void) => ({
  idColumn: {
    colId: 'id',
    headerName: t('headerCompanyId'),
    field: 'id',
    filter: 'agNumberColumnFilter',
    cellClass: 'paddingSmall',
    minWidth: 80,
    cellRenderer: ContactGroupIdCell,
    cellRendererParams: {
      openDetails,
    },
  },
  nameColumn: {
    colId: 'name',
    headerName: t('headerCompany'),
    field: 'name',
    filter: 'agTextColumnFilter',
    minWidth: 160,
    width: 280,
    cellRenderer: ContactGroupNameCell,
    cellRendererParams: {
      openDetails,
    },
  },
  contactGroupingNameColumn: {
    colId: 'contactGroupingName',
    headerName: t('headerContactGrouping'),
    field: 'contactGroupingName',
    filter: 'agTextColumnFilter',
  },
  websiteColumn: {
    colId: 'website',
    headerName: t('headerWebsite'),
    field: 'website',
    filter: 'agTextColumnFilter',
    cellRenderer: LinkCell,
    cellRendererParams: {
      getPath: (data: IContactGroup) => data.website,
      target: LinkTarget.BLANK,
      external: true,
    },
  },
  domainsColumn: {
    colId: 'domains',
    headerName: t('headerEmailDomains'),
    minWidth: 180,
    width: 280,
    field: 'domains',
    filter: 'agTextColumnFilter',
    cellRenderer: DomainsCell,
  },
});
